<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <div
        style="
          font-family: Consolas, 'Courier New', monospace;
          line-height: 19px;
        "
      >
        <div>
          &nbsp; &nbsp; &nbsp;
          根据《中华人民共和国食品安全法》及《网络食品安全违法行为查处办法》之规定，美滋来外卖作为网络食品交易第三方平台提供者，为切实加强对入网食品生产经营者(以下统称“入驻商户”)的审查登记工作，建立并执行以下制度:
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          1、对要求入驻美滋来外卖的商户，严格审查其经营主体的《营业执照》，纯经营类入驻商户的《食品经营许可证》;不具备合法主体资格的，不准予入驻经营。入驻商户应当依法取得许可，入驻商户应当按照许可的类别范围或经营项目从事食品经营。法律、法规规定不需要取得食品生产经营许可的除外。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          2、主体合法、经双方协商取得入驻资格的，必须与美滋来外卖签订入驻协议书，并提供真实合法的产品销售授权、商标注册证及商标使用授权书、合作产品的质量检测报告，明确双方的食品安全责任、义务;不签订协议书的，不得入驻经营。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          3、入驻商户应自觉建立和执行索证索票、质量查验等食品安全制度，销售的食品应来源合法、质量合格;经营设备应符合食品存储要求，经营环境应符合食品卫生条件和环境卫生要求，依法履行好食品安全责任、义务。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          4、美滋来外卖应建立入驻商户档案，入驻商户有义务提供食品的相关信息。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          5、美滋来外卖建立经营管理制度，落实工作人员的食品安全职责。入驻商户必须设置专门的食品安全管理机构或者指定专职食品安全管理人员，对亚台上架的食品及信息进行定期检查。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          6、美滋来外卖定期对入驻商户的经营环境和条件进行检查，发现食品经营者不具备与所经营食品相适应的经营环境和条件的，暂停或取消其入驻经营资格，发现经营不符合食品安全标准的食品或者有其他违法行为的，及时制止并立即报告辖区工商行政或食品药品监督管理机关。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          7、美滋来外卖主动接受相关管理机关的监督，自觉承担、认真履行其他各项食品安全义务。
        </div>
        <div>
          &nbsp; &nbsp; &nbsp;
          8、美滋来外卖工作人员必须严格遵守以上制度，不得违反食品安全自查制度。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
